<template>
  <div class="unauthorized">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-card class="mx-auto" max-width="344" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1"
                >UNAUTHORIZED</v-list-item-title
              >
              <v-list-item-subtitle
                >Your account has insufficient privilege.</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="$oidc.signInRedirect">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Unauthorized",
};
</script>

<style scoped>
.unauthorized {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 99999;
  color: #fff;
}
</style>